import { useEffect } from 'react';
import router from 'next/router';

import { useAppSelector } from '@src/hooks/index';

export const useProtectedRoute = (noUnsupportedCountry: boolean): boolean => {
    const { user, loading, initial_user_loaded } =
        useAppSelector((state) => state?.auth) || {};

    useEffect(() => {
        if (!initial_user_loaded) return;

        if (!user && !loading) {
            router.push('/login');
        } else if (user && noUnsupportedCountry && !user.country_supported) {
            router.push('/account');
        }
    }, [user, loading, noUnsupportedCountry, initial_user_loaded]);

    return (
        !user || loading || (noUnsupportedCountry && !user.country_supported)
    );
};
